import Button from "../../components/UI/Button";
import {Link} from "react-router-dom";
import React from "react";
import {checkPermission} from "../../util/auth";

const  OrderCardActions = ()=>{
  return (
    <div>
        {checkPermission(['ORDER_CREATE']) &&
        <Link to={`/orders/create`}>
            <Button
                text={<span className="mr_5 d_flex_center "><i className="lni lni-plus mr_5"></i> Create Order</span>}
                variant={"btn_black"}
            />
        </Link>
        }
    </div>
  );
}
export default OrderCardActions